const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    backgroundColor: "white",
  },
  header: {
    display: "flex",
    alignItems: "center",
    height: 45,
    px: 2,
    py: "14px",
    borderBottom: "1px solid #f3f4f6",
    flexShrink: 0,
    position: "relative",
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    color: "#6a7282",
    fontSize: 12,
    fontWeight: 500,
    textTransform: "none",
    minWidth: 0,
    p: 0,
    "&:hover": {
      backgroundColor: "transparent",
      color: "#364153",
    },
  },
  backIcon: {
    fontSize: 13,
  },
  title: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: 12,
    fontWeight: 600,
    color: "#1e2939",
    lineHeight: "16px",
  },
  body: {
    flex: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    px: 2,
    pt: "20px",
    gap: "20px",
  },
  intro: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  introBadge: {
    width: 56,
    height: 56,
    borderRadius: "12px",
    backgroundColor: "#eaf5ee",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: "12px",
  },
  introIcon: {
    fontSize: 22,
    color: "#1b4332",
  },
  introHeading: {
    fontSize: 16,
    fontWeight: 700,
    color: "#1e2939",
    lineHeight: "20px",
  },
  introCopy: {
    mt: "4px",
    fontSize: 12,
    color: "#6a7282",
    lineHeight: "18px",
    maxWidth: 240,
  },
  contactsCard: {
    border: "1px solid #f3f4f6",
    borderRadius: "12px",
    backgroundColor: "#fafafa",
    p: "12px 13px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  contactsLabel: {
    fontSize: 10,
    fontWeight: 500,
    color: "#99a1af",
    letterSpacing: "0.6px",
    textTransform: "uppercase",
    lineHeight: "15px",
  },
  contactRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    height: 28,
  },
  contactAvatar: {
    width: 20,
    height: 20,
    fontSize: 9,
    fontWeight: 600,
    color: "#4a5565",
    backgroundColor: "#f6c8d0",
  },
  contactName: {
    fontSize: 12,
    fontWeight: 500,
    color: "#1e2939",
    lineHeight: "16.5px",
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  contactEmail: {
    fontSize: 11,
    fontFamily: "Menlo, monospace",
    color: "#99a1af",
    lineHeight: "15px",
    flexShrink: 0,
  },
  optionCard: {
    width: "100%",
    textAlign: "left",
    p: "18px",
    borderRadius: "12px",
    border: "1px solid #e5e7eb",
    backgroundColor: "white",
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    cursor: "default",
    position: "relative",
  },
  optionCardPrimary: {
    backgroundColor: "#1b4332",
    border: "1px solid #1b4332",
    color: "white",
  },
  optionCardClickable: {
    cursor: "pointer",
    transition: "transform 120ms ease, box-shadow 120ms ease",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
    },
    "&.Mui-disabled": {
      opacity: 0.7,
      cursor: "not-allowed",
    },
  },
  optionIconWrap: {
    width: 32,
    height: 32,
    borderRadius: "8px",
    backgroundColor: "rgba(255,255,255,0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    mt: "2px",
  },
  optionIconWrapNeutral: {
    backgroundColor: "#f3f4f6",
  },
  optionIcon: {
    fontSize: 16,
    color: "white",
  },
  optionIconNeutral: {
    fontSize: 16,
    color: "#6a7282",
  },
  optionContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
  },
  optionTitlePrimary: {
    fontSize: 14,
    fontWeight: 700,
    color: "white",
    lineHeight: "17.5px",
  },
  optionTitleNeutral: {
    fontSize: 14,
    fontWeight: 700,
    color: "#1e2939",
    lineHeight: "17.5px",
  },
  optionCopyPrimary: {
    fontSize: 11,
    color: "rgba(255,255,255,0.85)",
    lineHeight: "17.875px",
  },
  optionCopyNeutral: {
    fontSize: 11,
    color: "#6a7282",
    lineHeight: "17.875px",
  },
  unlocksRow: {
    mt: "6px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    color: "white",
  },
  unlocksIcon: {
    fontSize: 11,
    color: "white",
  },
  unlocksLabel: {
    fontSize: 11,
    fontWeight: 500,
    color: "white",
    lineHeight: "15px",
  },
  chevron: {
    position: "absolute",
    top: "18px",
    right: "18px",
    fontSize: 12,
    color: "white",
  },
  decideLater: {
    alignSelf: "center",
    mt: "12px",
    mb: "20px",
    fontSize: 12,
    fontWeight: 500,
    color: "#6a7282",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "transparent",
      color: "#1e2939",
    },
  },
};

export default styles;
